import React, { useRef, useState, useEffect } from 'react';
import ReactOwlCarousel from 'react-owl-carousel';
import { Link } from 'react-router-dom';
import { isMobileOnly } from 'react-device-detect';
import { LuMoveRight, LuMoveLeft } from "react-icons/lu";
import axios from "axios";
import { base_url, postHeader } from '../../../../../../Helpers/request';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { BorderColor } from '@material-ui/icons';
import { Container } from 'react-bootstrap';


const BannerSlider = (props) => {
    const history = useHistory();
    const carouselRef = useRef(null);
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBanners = async () => {
            try {
                const response = await axios.get(`${base_url}/home/slider`, { headers: postHeader });
                if (response.data.status === 1) {
                    setBanners(response.data.data);
                    localStorage.setItem("bw-bannerdata", JSON.stringify(response.data.data));
                }
            } catch (error) {
                console.error("Error fetching banner data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBanners();
    }, []);
    

    const handleBannerAction = (slide) => {
        if (!slide) return;

        // Check if slider_id is 7 and newsletterRef exists
        if (String(slide.slider_id) === "7" && props.newsletterRef?.current) {
            props.newsletterRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
        }

        // Otherwise, navigate to the link
        if (slide.btn_link) {
            history.push(slide.btn_link);
        }
    };


    return (
        <div className="banner-slider position-relative">
            {/* Custom Navigation Buttons */}
            <button className="custom-nav-btn left" onClick={() => carouselRef.current?.prev()}>
                <LuMoveLeft />
            </button>
            <button className="custom-nav-btn right" onClick={() => carouselRef.current?.next()}>
                <LuMoveRight />
            </button>

            {/* Owl Carousel */}
<ReactOwlCarousel
  ref={carouselRef}
  className="owl-carousel owl-theme home-banner-slider"
  items={1}
  loop
  dots={!isMobileOnly}
  autoplay={true}
  autoplayTimeout={3000}
  autoplayHoverPause
  nav={false}
>
  {banners.map((slide, index) => (
    <div key={index} className="item">
      <div
        className="banner-slide"
        style={{
          backgroundImage: `url(${
            isMobileOnly ? slide.mobile_image : slide.image
          })`,
        }}
        onClick={() => handleBannerAction(slide)}
      >
        {/* Container added here */}
        <Container>
          {/* EXISTING CONTENT – unchanged */}
<div className={`content ${slide.text_direction_class}`}>

            <div>
                
           
            <h2 style={{ color: slide.text_color || "" }}>
              {slide.title}
            </h2>

            <p style={{ color: slide.text_color || "" }} className="m-0">
              {slide.short_text}
            </p>

            <div className="home_banner_slider_btn_box">
              {slide.btn_text && (
                <Link
                  style={{
                    borderColor: slide.text_color || "",
                    color: slide.text_color || "",
                  }}
                  className="btn solid-black"
                  to={slide.btn_link}
                >
                  {slide.btn_text}
                </Link>
              )}

              {slide.btn_text2 && (
                <Link
                  style={{
                    borderColor: slide.text_color || "",
                    color: slide.text_color || "",
                  }}
                  className="btn solid-black"
                  to={slide.btn_link2}
                >
                  {slide.btn_text2}
                </Link>
              )}
            </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  ))}
</ReactOwlCarousel>


        </div>
    );
};

export default BannerSlider;
